import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import NumberInput from '../../../../components/NumberInput';
import { partialUpdateCampaign, partialUpdateLineItem } from '../../../../store/slices/campaignManagementSlice';

const ImpressionsBookedInput = ({ defaultValue, campaignId, lineItemId }) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState(String(defaultValue));
  const [isDirty, setIsDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const handleChange = ({ target }) => {
    if (target.value !== value) {
      setIsDirty(true);
      setValue(target.value);
      if (isSaved) {
        setIsSaved(false);
      }
    }
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      if (lineItemId !== undefined) {
        await dispatch(partialUpdateLineItem({ campaignId, lineItemId, booked: value })).unwrap();
      } else {
        await dispatch(partialUpdateCampaign({ campaignId, booked: value })).unwrap();
      }
      setIsSaved(true);
      toast.success(`${lineItemId !== undefined ? 'Line Item' : 'Campaign'} updated`);
    } catch (error) {
      setIsSaved(false);
      toast.error(`Failed to update ${lineItemId !== undefined ? 'Line Item' : 'Campaign'}: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <NumberInput
      value={value}
      onChange={handleChange}
      InputProps={{
        sx: { '& input': { height: '18px', padding: '8px 14px' } },
        disabled: isLoading,
        renderSuffix: () =>
          isDirty &&
          !!value?.length && (
            <div className='bg-[#1b433226] cursor-pointer h-[34px] w-[60px] flex items-center justify-center'>
              {isLoading ? (
                <CircularProgress size={20} />
              ) : isSaved ? (
                <CheckCircleIcon />
              ) : (
                <CheckCircleOutlineIcon onClick={handleSave} />
              )}
            </div>
          ),
      }}
      NumberInputProps={{
        thousandsSeparator: ',',
        unmask: true,
      }}
      sx={[
        isDirty
          ? {
              '& .MuiInputBase-root': {
                border: {
                  border: '#1B4332',
                },
              },
            }
          : {
              '& .MuiInputBase-root': {
                border: {
                  border: '#DDE3E0',
                },
              },
            },
      ]}
      disableInputArrows
    />
  );
};

ImpressionsBookedInput.propTypes = {
  defaultValue: PropTypes.number,
  campaignId: PropTypes.number,
  lineItemId: PropTypes.number,
};

export default ImpressionsBookedInput;
